import * as React  from "react";

const New = () => {
  return(
    <>
      <div className="col-md-2 col-lg-3"></div>
      <h3>チケットマスタ作成</h3>
      <br/>
      <div className="center-block">
        <div className="row">
          <div className="col-md-2 col-lg-3"></div>
          <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6">
            <form className="new_m_ticket justify-content-center"
                  id="new_m_ticket"
                  action="/tickets/master/create"
                  acceptCharset="UTF-8"
                  method="post">
              <label htmlFor="m_ticket_issue_number">名前</label>
                    <span className="label label-danger ml5">必須</span>
                    <input className="form-control"
                          placeholder="Followcare SMS送信チケット（100回送信）"
                          name="m_ticket[name]"
                          id="name" />
              <label htmlFor="m_ticket_issue_number">発行枚数</label>
              <span className="label label-danger ml5">必須</span>
              <input className="form-control"
                    placeholder="100"
                    type="number"
                    name="m_ticket[issue_number]"
                    id="m_ticket_price" />
              <label htmlFor="m_ticket_price">金額(税抜)</label>
              <span className="label label-danger ml5">必須</span>
              <input className="form-control"
                    placeholder="1100"
                    type="number"
                    name="m_ticket[price]"
                    id="m_ticket_price" />
              <label htmlFor="m_ticket_valid_period_day">有効日数</label>
              <span className="label label-danger ml5">必須</span>
              <input className="form-control"
                    placeholder="365"
                    type="number"
                    name="m_ticket[valid_period_day]"
                    id="m_ticket_valid_period_day" />
              <a className="btn btn-primary pull-left ml5 message-template-edit-btn" href="/">戻る</a>
              <input type="submit"
                     name=""
                     value="作成する"
                     className="btn btn-primary pull-right message-template-edit-btn"
                     id=""
                     data-disable-with="作成する"></input>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default New
